import { makeStyles } from 'tss-react/mui';

const useStylesPageContainerSide: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  pageContainerSide: {
    width: '20%',
    '& > div': {
      textAlign: 'center',
      margin: '0 auto',
    },
    [theme.breakpoints.down('xl')]: {
      width: '25%',
    },
    [theme.breakpoints.down('lg')]: {
      width: '35%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

export default useStylesPageContainerSide;
